import WidgetEntity from '../../WidgetEntity';
import * as Widgets from '@mm/constants/widgets';

export class FormWidget extends WidgetEntity {
  static make(pageId: number, sortOrder: number) {
    return {
      ...super.make(pageId, Widgets.FORM, 'Untitled Form', sortOrder),
      config: {},
    };
  }
}
